import React from 'react';

function BotIconClose() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 146 146"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M141.014 4.98593C137.821 1.79344 133.49 0 128.974 0C124.459 0 120.128 1.79344 116.935 4.98593L72.8972 49.0235L28.8596 4.98593C25.6479 1.88392 21.3463 0.167469 16.8813 0.206268C12.4162 0.245068 8.1451 2.03601 4.98774 5.19337C1.83038 8.35072 0.0394435 12.6219 0.00064375 17.0869C-0.038156 21.5519 1.67829 25.8535 4.7803 29.0652L48.8179 73.1028L4.7803 117.14C1.67829 120.352 -0.038156 124.654 0.00064375 129.119C0.0394435 133.584 1.83038 137.855 4.98774 141.012C8.1451 144.17 12.4162 145.961 16.8813 145.999C21.3463 146.038 25.6479 144.322 28.8596 141.22L72.8972 97.1821L116.935 141.22C120.147 144.322 124.448 146.038 128.913 145.999C133.378 145.961 137.649 144.17 140.807 141.012C143.964 137.855 145.755 133.584 145.794 129.119C145.833 124.654 144.116 120.352 141.014 117.14L96.9765 73.1028L141.014 29.0652C144.207 25.8718 146 21.5411 146 17.0256C146 12.51 144.207 8.17938 141.014 4.98593Z"
        fill="white"
      />
    </svg>
  );
}
export default BotIconClose;
